module.exports = __webpack_public_path__ + "static/media/new-client.a2db800e.jpg";